import { UnityLibrary } from "./UnityLibrary";

export class SteamworksNetLibrary
{
  public static readonly token = "steamworks-net";
  public static keywords:string[] = 
  [
    "SteamAPI","SteamFriends","SteamUser","SteamUserStats",
    "CallResult",

    "SteamLeaderboard_t","SteamLeaderboardEntries_t","LeaderboardScoresDownloaded_t","ELeaderboardDataRequest",
    "ELeaderboardUploadScoreMethod"
  ]
  
}